import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ActivationCodeService {
  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getActivationCodes() {
    return this.http.get(
      `${this.baseUrl}/v1/activation-code`
    );
  }

  generateBatch(payload: {
    roleId: number;
    formId: number;
    count: number;
    expiresAt: string;
  }) {
    return this.http.post(
      `${this.baseUrl}/v1/activation-code/batch`,
      payload
    );
  }

  revokeActivationCode(activationCodeId: number) {
    return this.http.post(
      `${this.baseUrl}/v1/activation-code/${activationCodeId}/revoke`,
      {}
    );
  }
}